import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as UC from './utility.component';
import * as UD from './utility.directive';
import * as UP from './utility.pipe';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule
	],
	declarations: [
		UC.FeatureNotAvailableDialog,
		UC.ReadMoreDialog,
		UC.FeatureNotAvailable2BDialog,
		UC.ScrollOnHoverComponent,
		UD.GridsterLazyLoadDirective,
		UD.ImgCheckDirective,
		UD.CardImgLazyLoadDirective,
		UD.CarouselNoWrapDirective,
		UD.TrackVisibilityDirective,
		UD.AlphaNumericDirective,
		UD.AlphaNumericSpacePeriodDirective,
		UP.SafePipe,
		UP.FormatDateTimePipe,
		UP.FormatDatePipe,
		UP.RangePipe
	],
	exports: [
		UC.FeatureNotAvailableDialog,
		UC.ReadMoreDialog,
		UC.FeatureNotAvailable2BDialog,
		UC.ScrollOnHoverComponent,
		UD.GridsterLazyLoadDirective,
		UD.ImgCheckDirective,
		UD.CardImgLazyLoadDirective,
		UD.CarouselNoWrapDirective,
		UD.TrackVisibilityDirective,
		UD.AlphaNumericDirective,
		UD.AlphaNumericSpacePeriodDirective,
		UP.SafePipe,
		UP.FormatDateTimePipe,
		UP.FormatDatePipe,
		UP.RangePipe
	]
})
export class UtilityModule { }
